var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#5A4A99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2414 21C9.85857 21 9.532 20.8603 9.26171 20.581C8.992 20.3016 8.85714 19.9634 8.85714 19.5663V8.57134H8V7.68358H11.4286V7H16.5714V7.68358H20V8.57134H19.1429V19.5663C19.1429 19.9746 19.0109 20.3155 18.7469 20.589C18.4823 20.863 18.1529 21 17.7586 21H10.2414ZM18.2857 8.57134H9.71429V19.5663C9.71429 19.7255 9.76371 19.8563 9.86257 19.9587C9.96143 20.061 10.0877 20.1122 10.2414 20.1122H17.7586C17.89 20.1122 18.0109 20.0554 18.1211 19.9418C18.2309 19.8276 18.2857 19.7024 18.2857 19.5663V8.57134ZM12.1211 18.3367H12.9783V10.3469H12.1211V18.3367ZM15.0217 18.3367H15.8789V10.3469H15.0217V18.3367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.38273bd6b369115c340b78653b651136.svg";
export { ForwardRef as ReactComponent };